import React from 'react';
import './Banner.scss';

const Banner = () => {
  return <h1 className="banner">Zack Leaman</h1>;
};

export default Banner;
